export const MAX_ATTEMPTS_TO_PASS_INTERACTIVE_ARTICLE = 2;
